<template>
    <div id="RaiseNewCaseItemStyleOne">
        <a-row>
            <a-col :span="24" class="titleArea">
                {{title}}
            </a-col>
        </a-row>
        <a-row>
           <a-col :span="11" >
               <a-row v-for="(item, index) in lInputConfig" :key="index">
                   <NormalInput :isCanEdit="isCanEdit" v-if="item.inputStyle !== 'upload'" :data="item" ></NormalInput>
                   <NormalUpload :isCanEdit="isCanEdit" v-if="item.inputStyle === 'upload'" :data="item" @uploadFile="fileData"></NormalUpload>
               </a-row>
           </a-col>
            <a-col :span="11" :offset="2">
                <a-row v-for="(item, index) in rInputConfig" :key="index">
                    <NormalInput :isCanEdit="isCanEdit" v-if="item.inputStyle !== 'upload'" :data="item" ></NormalInput>
                    <NormalUpload :isCanEdit="isCanEdit" v-if="item.inputStyle === 'upload'" :data="item" @uploadFile="fileData"></NormalUpload>
                </a-row>
            </a-col>
        </a-row>
    </div>
</template>

<script>
import NormalInput from './NormalInput'
import NormalUpload from './NormalUpload'

export default {
  name: 'RaiseNewCaseItemStyleOne',
  components: {
    NormalInput,
    NormalUpload
  },
  props: ['lInputConfig', 'rInputConfig', 'title', 'isCanEdit'],
  data () {
    return {}
  },
  destroyed () {
  },
  created () {
  },
  methods: {
    fileData (fileDate) {
      this.$emit('uploadFile', fileDate)
    }
  }
}
</script>

<style lang="scss" scoped>
    ::-webkit-scrollbar {
        display: none;
    }
    #RaiseNewCaseItemStyleOne {
    .titleArea {
        padding: 5px;
        border-bottom: 1px solid #91d5ff;
        color: #027DB4;
        font-weight: 800;
        font-size: 16px;
    }
    }

</style>
